<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    div.py-6.px-10
      .text-lg.font-semibold.mb-2 Are you sure you want to edit this?
      .text-md.mb-2 Editing this file will revert the order status from “Completed” into the status before it.
      .text-md Click “Confirm” to undo the order completion
    v-divider
    v-card-actions.px-6
      v-spacer
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-btn.button-md(:loading="isLoading" depressed dark @click="handleConfirm") {{ $t('confirm') }}
</template>
  
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    },
    selectedDocument: {
      type: Object,
      required: true
    },
    parentData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    },
    getEndpoint () {
      const baseEndpoint = `/purchases/${this.company.slug}`
      switch (this.selectedDocument.id) {
        case 'quotation':
          return `${baseEndpoint}/quotations`

        case 'purchase-order':
          return `${baseEndpoint}/orders`

        case 'invoice':
          return `${baseEndpoint}/invoices`
      
        default:
          return ''
      }
    },
    async handleConfirm () {
      try {
        this.isLoading = true
        const endpoint = `${this.getEndpoint()}/${this.parentData.id}`
        const payload = { order_status: 'active' }
        await this.axios.patch(endpoint, payload)
        this.updateActivityLog(endpoint, payload, null, 'PATCH', this.parentData.id)
        this.$emit('updated')
        this.showMessage(['success', 'Status changed to active successfully'])
        this.closeDialog()
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id,
        object_ref: null,
        activity: `${this.selectedDocument.id} confirm edit`,
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
</style>